export default "__VITE_ASSET__BQxZVHRX__"